<template>
    <div>
        <!--面包屑-->
        <p class="breadcrumb">MANAGE STUDENTS</p>

        <!--上方操作框-->
        <el-row type="flex" class="row-bg p-10 mt-10 bg-lightgarg" justify="space-between">
            <el-col :span="5" class="mr-10">
                <el-select filterable no-match-text="No data" noDataText="No data" v-model="selecttripvalue" clearable placeholder="Trip" @change="getselectlist" style="width: 100%">
                    <el-option v-for="item in options" :label="item.name" :key="item.id" :value="item.id"></el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <el-input  class="input-setMaxWidth" placeholder="Search anything about users" v-model="message" @keyup.enter.native="handleIconClick">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClick"></i>
                </el-input>
            </el-col>
            <el-col :span="11" class="text-right">
                <div class="grid-content">
                    <a :href="templateUrl" class="white"><el-button type="primary">
                        <i class="icon ion-android-download"></i> Template</el-button>
                    </a>

                    <el-upload class="upload" accept=".xlsx" :show-file-list="false" action="/api/student/import"
                               :on-success="importStudent"
                               :on-error="failUpload" :before-upload="beforeUpload">
                        <el-button type="success"><i class="icon ion-android-upload"></i> Import</el-button>
                    </el-upload>
                </div>
            </el-col>
        </el-row>

        <!--下方表格-->
        <el-table empty-text="No data" :data="users" border v-loading="loading" element-loading-text="loading..." style="width: 100%" class="mt-20">
            <el-table-column label="Name" width="210">
                <template slot-scope="scope">
                    <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="school" label="Affiliation" min-width="190"></el-table-column>
            <el-table-column prop="trip" label="Trips" width="160"></el-table-column>
            <el-table-column prop="action" label="Edit Enabled" width="130" align="center">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.editEnabled"
                    @change="editEnable(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="Actions" width="130" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="Editstudent(scope.row)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" @click="removestudent(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页符-->
        <div class="text-center mt-20 mb-50">
            <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPage" :page-count="totalPages"
                           @current-change="pageCurrentChange">
            </el-pagination>
        </div>

        <!--修改学生信息弹窗-->
        <el-dialog title="Edit User" customClass="dialogStyle" :visible.sync="Editdialog">
            <el-form :model="editform" :rules="editrules" ref="editform" label-width="145px">
                <el-form-item label="Email Address" prop="Eemail">
                    <el-input placeholder="Email Address" v-model="editform.Eemail" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Change Password" prop="checked">
                    <el-checkbox v-model="checked" @change="changePass" >Change Password</el-checkbox>
                </el-form-item>

                <template v-if="willshow">
                    <el-form-item label="Password" prop="Epassword">
                        <el-input type="password" v-model="editform.Epassword" placeholder="Password should contain 8 to 20 characters."></el-input>
                    </el-form-item>
                    <el-form-item label="Confirm Password" prop="EconfirmPassword">
                        <el-input type="password" v-model="editform.EconfirmPassword" placeholder="Confirm Password" ></el-input>
                    </el-form-item>
                </template>
                <el-form-item label="Given Name" prop="EgivenName">
                    <el-input v-model="editform.EgivenName" placeholder="Given Name" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Family Name" prop="EfamilyName">
                    <el-input v-model="editform.EfamilyName" placeholder="Family Name" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Display Name" prop="EdisplayName">
                    <el-input v-model="editform.EdisplayName" placeholder="Display Name" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Affiliation" prop="Eschool">
                    <el-input v-model="editform.Eschool" placeholder="Affiliation" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Trips" prop="trip">
                    <el-select no-match-text="No data" no-data-text="No data" filterable v-model="dialogtripid"  placeholder="Please select trip"  @change="isTripDirty = true"  @visible-change="showTripList">
                        <el-option v-for="item in options" :label="item.name" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Mobile Phone" prop="EmobilePhone">
                    <el-input v-model="editform.EmobilePhone" placeholder="Mobile Phone" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Father Phone" prop="EfatherPhone">
                    <el-input v-model="editform.EfatherPhone" placeholder="Father Phone" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Mother Phone" prop="EmotherPhone">
                    <el-input v-model="editform.EmotherPhone" placeholder="Mother Phone" @change="isDirty = true"></el-input>
                </el-form-item>
                <el-form-item label="Deadline1" prop="EDeadline1">
                    <el-date-picker v-model="editform.EDeadline1" type="date" :picker-options="pickerOptions" placeholder="Please select deadline"  @change="isDirty = true"></el-date-picker>
                </el-form-item>
                <el-form-item label="Deadline2" prop="EDeadline2">
                    <el-date-picker v-model="editform.EDeadline2" type="date" :picker-options="pickerOptions" placeholder="Please select deadline"  @change="isDirty = true"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Editdialog = false">Close</el-button>
                <el-button type="primary" @click="submitedit('editform')" :loading="saveBtnIsLoading">Save</el-button>
            </div>
        </el-dialog>

        <!--导入学生已存在学生弹窗-->
        <el-dialog :title="existeddialog_title" :visible.sync="existeddialog" width="90%" customClass="dialogWidth-1000">
            <el-table empty-text="No data" max-height="250" :data="existedList" border v-loading="loading" element-loading-text="loading..." style="width: 100%" class="mb-20">
                <el-table-column  type="index" width="60" align="center"></el-table-column>
                <el-table-column prop="name" label="Name" width="220">
                    <template slot-scope="scope">
                        <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                        <el-tooltip class="item"  v-if="scope.row.trashed == true" effect="dark" content="Deleted" placement="right">
                            <i class="el-icon-delete gary"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="Email" min-width="200"> </el-table-column>
                <el-table-column prop="action" label="Actions" width="300">
                    <template slot-scope="props">
                        <el-radio-group v-model="ExistAction[props.$index]">
                            <el-radio label="Update">Update</el-radio>
                            <el-radio label="New" >New Report</el-radio>
                            <el-radio label="Skip" >Skip</el-radio>
                        </el-radio-group>
                    </template>
                </el-table-column>
            </el-table>
            <ul class="actionIntro p-20">
                <li>Update: 用新导入的学生信息覆盖更新已有信息</li>
                <li>Skip: 什么也不做跳过此条学生信息</li>
                <li>New Report: 适用于学生重复参加项目的情况，会将当前报告归档并生成新的报告，请谨慎选择</li>
            </ul>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importexitedAllSkip">All Skip</el-button>
                <el-button type="primary" :loading="saving" @click="importexitedStu">Save</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import md5 from '../../component/md5'
    export default {
        data() {
            //修改用户信息密码自动验证
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Password Required'));
                } else {
                    if (this.editform.EconfirmPassword !== '') {
                        this.$refs.editform.validateField('EconfirmPassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('ConfirmPassword Required'));
                } else if (value !== this.editform.Epassword) {
                    callback(new Error('Passwords do not match!'));
                } else {
                    callback();
                }
            };
            return {
                templateUrl: require('../../assets/user-template.xlsx'),
                //搜索栏
                message: '',
                selecttripvalue: '',
                options: [{
                    id: 0,
                    name: ''
                }],
                users: [],//学生表格
                role: 'student',//student代表未查看学生列表
                trashed: 0,//0代表未删除学生
                currentPage: 1,
                size: 15,
                totalPages: 1,
                // loading过渡效果变量
                loading: true,
                saveBtnIsLoading: false,

                isDirty: false,
                isTripDirty:false,

                //修改信息弹窗
                dialogtripvalue: '',
                dialogtripid: '',
                formLabelWidth: '130px',
                checked: false,
                willshow: false,//修改弹窗修密码框是否显示
                Editdialog: false,
                editform: {
                    EDeadline2:'',
                    EDeadline1:'',
                    EmotherPhone:'',
                    EfatherPhone:'',
                    Eschool:'',
                    EdisplayName:'',
                    EfamilyName:'',
                    EgivenName:'',
                    Eemail:'',
                    EmobilePhone:'',
                    Epassword:'',
                    EconfirmPassword:'',
                },
                pickerOptions: {//修改弹窗deadline
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                editrules: {
                    Eemail: [
                        {required: true, message: 'Email Adress Required', trigger: 'blur'},
                        {type: 'email', message: 'Email format invalid.'},
                    ],
                    Epassword: [
                        {required: true, message: 'Password Required', trigger: 'blur'},
                        {validator: validatePass, trigger: 'blur'},
                        {min: 8, max: 20, message: 'Password should contain 8 to 20 characters.', trigger: 'blur'},
                        {pattern: /^\w{8,20}$/, message: "Only numbers, letters, and underscores allowed.", trigger: 'blur'}
                    ],
                    EconfirmPassword: [
                        {required: true, message: 'Confirm Password Required', trigger: 'blur'},
                        {validator: validatePass2, trigger: 'blur'},
                    ],
                    EgivenName: [
                        {required: true, message: 'GivenName Required', trigger: 'blur'},
                        {max: 30, message: 'givenName should not more than 30 characters.', trigger: 'blur'}
                    ],
                    EfamilyName: [
                        {required: true, message: 'FamilyName Required', trigger: 'blur'},
                        {max: 30, message: 'familyName should not more tha 30 characters.', trigger: 'blur'}
                    ],
                    EdisplayName: [
                        {required: true, message: 'DisplayName Required', trigger: 'blur'},
                        {max: 60, message: 'displayName should not more tha 60 characters.', trigger: 'blur'}
                    ],
                    Eschool: [
                        {required: true, message: 'Affiliation Required', trigger: 'blur'},
                        {max: 100, message: 'Affiliation Name should not more tha 100 characters.', trigger: 'blur'}
                    ],
                    EmobilePhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                    EmotherPhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ],
                    EfatherPhone: [
                        {required: false,},
                        {pattern: /^1\d{10}$/, message: 'Phone number format invalid.', trigger: 'blur'}
                    ]
                },

                //导入学生
                saving:false,
                fileName: '',
                warningList: [],
                errorList: [],
                existeddialog: false,
                existeddialog_title: '',
                existedList: [],
                ExistAction: [],

                successCount: 0,
                warningCount: 0,
                warningMessage: '',
                errorCount: 0,
                errorMessage: ''

            };

        },
        mounted: function () {
            this.$nextTick(function () {
                this.getusers();
                this.getTrip();
                this.getEditEnabled()
            })

        },
        methods: {
            editEnable(student) {
               this.$http.get(`/student/editEnable/${student.id}?enabled=${student.editEnabled}`).catch(error=> {
                 this.$message.error(error.message);
               })
            },

            //获取学生列表通用函数
            getusers(){
                this.loading = true;
                this.$http.get('user?role=' + this.role + '&trashed=' + this.trashed + '&page=' + (this.currentPage - 1) + '&tripId=' + this.selecttripvalue + '&keywords=' + this.message).then(response => {
                    //渲染数据
                    this.users = response.list;
                    this.totalPages = response.totalPages;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false
                    this.$message.error(error.message)
                })
            },

            //获取弹窗信息
            Editstudent(user){
                this.id = user.id;
                this.editform.EmotherPhone = user.motherPhone;
                this.editform.EfatherPhone = user.fatherPhone;
                this.editform.Eschool = user.school;
                this.dialogtripid = user.tripId;
                this.editform.EdisplayName = user.displayName;
                this.editform.EfamilyName = user.familyName;
                this.editform.EgivenName = user.givenName;
                this.editform.Eemail = user.email;
                this.editform.EmobilePhone = user.mobilePhone;
                this.editform.EDeadline1 = user.deadline1;
                this.editform.EDeadline2 = user.deadline2;
                this.Editdialog = true;
                this.editform.Epassword = '';
                this.editform.EconfirmPassword = '';
                this.checked = false;
                this.willshow = false;
            },

            //获取trip列表
            getTrip(){
                this.$http.get('trip/list').then(response => {
                    this.options = response;
                }).catch(error => {
                    this.$message.error(error.message)
                })
            },
            showTripList(){
                this.getTrip()
            },

            //给学生修改trip
            ChangeTrip(){
//                if(this.dialogtripid != null){
                    if(this.isTripDirty){
                        this.$http.put('trip/choose?studentId='+ this.id +'&tripId=' + this.dialogtripid).then(response => {
                            this.getusers();
                            this.Editdialog = false;
                        }).catch(error => {
                            this.$message.error(error.message);
                            this.getusers();
                            this.Editdialog = false;
                        })
                    }else{
                        this.getusers();
                        this.Editdialog = false;
                    }
//                }else{
//                    this.getusers();
//                    this.Editdialog = false;
//                }
                this.isTripDirty = false;

            },

            //输入关键字搜索
            handleIconClick() {
                this.getusers();
            },

            //改变当前页函数
            pageCurrentChange(val){
                this.currentPage = val;
                this.getusers();
            },

            //选择trip条件后获取学生列表
            getselectlist(){
                this.getusers();
            },

            //删除学生
            removestudent(user){
                this.$confirm('Are you sure you want to trash user: ' + user.displayName + '-' +user.givenName + '  ' + user.familyName, 'Trash User', {
                    confirmButtonText: 'Trash',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'el-button--danger',
                    type: 'warning',
                    confirmButtonLoading : false,
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            instance.confirmButtonLoading = true;
                            done();
                        } else {
                            instance.confirmButtonLoading = false;
                            done();
                        }
                    }
                }).then(() => {
                    this.$http.patch('user/trash/' + user.userId).then(response => {
                        this.getusers();
                    }).catch(error => {
                        this.Trashdialog = false;
                        this.$message.error(error.message)
                    })
                }).catch(() => {//弹窗点击cancel后执行的方法

                });
            },

            //编辑学生
            changePass(){
                if(this.checked === true){
                    this.willshow =true;
                    this.isDirty = true;
                }else {
                    this.willshow =false;
                }
            },
            submitedit(formName) {
//                console.log('TripDirty:'+ this.isTripDirty)
//                console.log('Dirty:'+ this.isDirty)
                if(!this.isDirty && !this.isTripDirty){//没有修改过弹窗则点击提交直接关闭
                    this.Editdialog = false;
                    return;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveBtnIsLoading = true;
                        var api = {
                            email: this.editform.Eemail,
                            familyName: this.editform.EfamilyName,
                            givenName: this.editform.EgivenName,
                            displayName: this.editform.EdisplayName,
                            mobilePhone: this.editform.EmobilePhone,
                        };
                        if(this.checked === true){
                            var EPwd_md5 = md5.hex_md5(this.editform.Epassword);
                            api.password = EPwd_md5;
                        }
//                        console.log(api);
                        this.$http.put('student', {
                            id: this.id,
                            motherPhone: this.editform.EmotherPhone,
                            fatherPhone: this.editform.EfatherPhone,
                            school: this.editform.Eschool,
                            deadline1: this.editform.EDeadline1,
                            deadline2: this.editform.EDeadline2,
                            user: api
                        }).then(response => {
                            this.ChangeTrip();
                            this.loading = true;
                            api.password = undefined;
//                            this.getusers();
                            this.saveBtnIsLoading = false;
                        }).catch(error => {
                            this.loading = false;
                            this.Editdialog = false;
                            this.saveBtnIsLoading = false;
                            this.$message.error(error.message)
                        })

                    } else {
                        return false;
                    }
                });
                // 提交修改不主动将表单是否改动变为false，解决当修改密码时出现警告提示，并且前后修改了其他信息，此时提交发现不成功。
                // 于是选择不修改密码，再次保存修改，会发现之前修改的其他信息并没有被保存，因为第一次保存后isDirty已经变成false了，
                // 第二次再保存时，被认为是表单未修改状态，Dialog直接= > false的情况。
                 // this.isDirty = false;
            },


            //导入学生
            importStudent(importres, file, fileList){
                this.warningList = importres.r.warningList;
                this.errorList = importres.r.errorList;
                this.existedList = importres.r.existedList;
                this.ExistAction = new Array();//定义radio的model只为数组，index加索引
                const h = this.$createElement;

                for (var a = 0; a < importres.r.existedList.length; a++) {//Update
                    this.ExistAction.push('Update');
                }

                //成功提示
                this.successCount = importres.r.successCount;//记录第一次成功几条

                //警告列表
                this.warningCount = importres.r.warningList.length;//记录第一次警告几条信息
                for (var i = 0; i < this.warningCount; i++) {
                    if(importres.r.warningList[i].name != ""){
                        this.warningMessage += '('+(i+1)+')' + importres.r.warningList[i].name + ': ' + importres.r.warningList[i].field + ' ' + importres.r.warningList[i].type + '\n';
                    }else {
                        this.warningMessage += '('+(i+1)+')' + importres.r.warningList[i].email + ': ' + importres.r.warningList[i].field + ' ' + importres.r.warningList[i].type + '\n';
                    }

                }

                //错误列表
                for (var j = 0; j < importres.r.errorList.length; j++) {
                    if(importres.r.errorList[j].email !== ""){
                        if(importres.r.errorList[j].name !== ""){//如果那么不存在则显示邮箱
                            this.errorMessage +='('+(j+1)+')' + importres.r.errorList[j].name + ': ' + importres.r.errorList[j].field + ' ' + importres.r.errorList[j].type + '\n';
                        }else {
                            this.errorMessage +='('+(j+1)+')' + importres.r.errorList[j].email + ': ' + importres.r.errorList[j].field + ' ' + importres.r.errorList[j].type + '\n';
                        }
                    }else {
                        this.errorMessage +='('+(j+1)+')' + 'Empty email or line'+ '\n';
                    }
                    this.errorCount++;
                }

                //如果不存在系统已有用户，则直接弹窗结果
                if (importres.r.existedList.length === 0) {
                    if(this.successCount>0){
                        setTimeout(() => {
                            this.$notify.success({
                                title: 'Success',
                                message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.successCount + ' students were imported successfully',),
                            });
                            this.successCount = 0;
                        }, 100);
                    }

                    if(this.warningCount>0){
                        setTimeout(() => {
                            this.$notify.warning({
                                title: this.warningCount + ' Warning',
                                message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.warningMessage),
                                duration: 0,
                            });
                            this.warningCount = 0;
                            this.warningMessage = '';
                        }, 100);
                    }

                    if(this.errorCount>0){
                        setTimeout(() => {
                            this.$notify.error({
                                title: this.errorCount + ' Error',
                                message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.errorMessage),
                                duration: 0,
                            });
                            this.errorCount = 0;
                            this.errorMessage = '';
                        }, 100);
                    }
                    this.getusers();

                } else {//存在系统已有用户，则记录第一次错误几条信息
                    this.existeddialog = true;
                    this.existeddialog_title = importres.r.existedList.length + ' student already existed, you want ';
                }
            },
            beforeUpload(file){
                var filetype = "xlsx";
                var filesize = 1024 * 50;
                const isLt50M = file.size / filesize < 50;
                if (file.name.toLowerCase().indexOf(filetype) != -1) {
                    return true;
                } else {
                    this.$message.error('Only .xlsx allowed');
                    return false;
                }
                if (!isLt50M) {
                    this.$message.error('The size of the PDF file should be less than 50MB.');
                    return false;
                }

            },
            failUpload(){
                this.$message.error('File to import, Please try again later.');
            },


            importexitedAllSkip(){
                const h = this.$createElement;
                this.existeddialog = false;
                this.getusers();
                if(this.successCount>0){
                    setTimeout(() => {
                        this.$notify.success({
                            title: 'Success',
                            message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.successCount + ' students were imported successfully',),
                        });
                        this.successCount = 0;
                    }, 100);
                }

                if(this.warningCount>0){
                    setTimeout(() => {
                        this.$notify.warning({
                            title: this.warningCount + ' Warning',
                            message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.warningMessage ),
                            duration: 0,
                        });
                        this.warningCount = 0;
                        this.warningMessage = '';
                    }, 100);
                }

                if(this.errorCount>0){
                    setTimeout(() => {
                        this.$notify.error({
                            title: this.errorCount + ' Error',
                            message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.errorMessage ),
                            duration: 0,
                        });
                        this.errorCount = 0;
                        this.errorMessage = '';
                    }, 100);
                }
            },
            //导入已存在学生
            importexitedStu(){
                //创建提交给后台的新数组，为空，如果操作new置为true加入新数组，如果操作update置为false加入新数组中传入
                var importList = new Array();
                for (var i = 0; i < this.ExistAction.length; i++) {
                    if (this.ExistAction[i] == "New") {
                        this.existedList[i].newReport = true;
                        importList.push(this.existedList[i]);
                    } else if (this.ExistAction[i] == "Update") {
                        this.existedList[i].newReport = false;
                        importList.push(this.existedList[i]);
                    } else {
                        continue;
                    }
                }
                this.saving = true;

                //点击提交调用接口
                this.$http.post('student/importExisted', importList).then(res => {
                    const h = this.$createElement;
                    //成功提示
                    this.existeddialog = false;
                    this.successCount += res.successCount;
                    if(this.successCount>0){
                        setTimeout(() => {
                            this.$notify.success({
                                title: 'Success',
                                message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.successCount + ' students were imported successfully',),
                            });
                            this.successCount = 0;
                        }, 100);
                    }

                    //警告列表
                    this.warningCount += res.warningList.length;
                    for (var i = 0; i < res.warningList.length; i++) {
                        if(res.warningList[i].name != ""){
                            this.warningMessage += '('+(i+1)+')' + res.warningList[i].name + ': ' + res.warningList[i].field + ' ' + res.warningList[i].type + '\n';
                        }else {
                            this.warningMessage += '('+(i+1)+')' + res.warningList[i].email + ': ' + res.warningList[i].field + ' ' + res.warningList[i].type + '\n';
                        }

                    }
                    if (this.warningCount > 0) {
                        setTimeout(() => {
                            this.$notify.warning({
                                title: this.warningCount + ' Warning',
                                message: h('div', {style:{wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.warningMessage),
                                duration: 0,
                            });
                            this.warningCount = 0;
                            this.warningMessage = '';
                        }, 100);
                    }


                    //错误列表
                    for (var i = 0; i < res.errorList.length; i++) {
                        this.errorCount++;
                        if(res.errorList[i].email != ""){
                            if(res.errorList[i].name != ""){
                                this.errorMessage += '('+this.errorCount+')' + res.errorList[i].name + ': ' + res.errorList[i].field + ' ' + res.errorList[i].type + '\n';
                            }else {
                                this.errorMessage += '('+this.errorCount+')' + res.errorList[i].email + ': ' + res.errorList[i].field + ' ' + res.errorList[i].type + '\n';
                            }
                        }else {
                            this.errorMessage +='('+(j+1)+')' + 'Empty email or line'+ '\n';
                        }

                    }
                    if (this.errorCount > 0) {
                        setTimeout(() => {
                            this.$notify.error({
                                title: this.errorCount + ' Error',
                                message: h('div', {style: {wordWrap:'break-word', textAlign:'start', whiteSpace:'pre'}}, this.errorMessage,),
                                duration: 0,
                            });
                            this.errorCount = 0;
                            this.errorMessage = '';
                        }, 100);
                    }
                    this.getusers();
                    this.saving = false;
                }).catch(error => {
                    this.Creatdialog = false;
                    this.$message.error(error.message)
                })
            }

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/variable";
    .actionIntro{
        background: $content-bg;
        border: 1px solid $header-color;
        list-style: inside disc;
        li{
            line-height: 24px;
        }
    }

</style>


// WEBPACK FOOTER //
// Student.vue?9bd1092c